{
  "all-devices": {
    "nav-item": {
      "label": "Apparaten"
    }
  },
  "deployments": {
    "nav-item": {
      "label": "Inzet"
    }
  },
  "deployment-rings": {
    "nav-item": {
      "label": "Rings"
    }
  },
  "documentation": {
    "nav-item": {
      "label": "Documentatie"
    }
  },
  "home": {
    "nav-item": {
      "label": "Home"
    }
  },
  "page-not-found": {
    "message": "De pagina die u zoekt, bestaat niet of is verplaatst.",
    "title": "Pagina niet gevonden"
  },
  "software-management": {
    "nav-item": {
      "label": "Softwarebeheer"
    }
  }
}
